'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EventDelegator = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ScopeChecker = require('./ScopeChecker');

var _util = require('./util');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function patchEvent(event) {
  var pEvent = event;
  pEvent.propagationHasBeenStopped = false;
  var oldStopPropagation = pEvent.stopPropagation;
  pEvent.stopPropagation = function stopPropagation() {
    oldStopPropagation.call(this);
    this.propagationHasBeenStopped = true;
  };
  return pEvent;
}

function mutateEventCurrentTarget(event, currentTargetElement) {
  try {
    Object.defineProperty(event, 'currentTarget', {
      value: currentTargetElement,
      configurable: true
    });
  } catch (err) {
    console.log('please use event.ownerTarget');
  }
  event.ownerTarget = currentTargetElement;
}

var EventDelegator = exports.EventDelegator = function () {
  function EventDelegator(topElement, eventType, useCapture, isolateModule) {
    var _this = this;

    _classCallCheck(this, EventDelegator);

    this.topElement = topElement;
    this.eventType = eventType;
    this.useCapture = useCapture;
    this.isolateModule = isolateModule;
    this.roof = topElement.parentElement;
    this.destinations = [];

    if (useCapture) {
      this.domListener = function (ev) {
        return _this.capture(ev);
      };
    } else {
      this.domListener = function (ev) {
        return _this.bubble(ev);
      };
    }

    topElement.addEventListener(eventType, this.domListener, useCapture);
  }

  _createClass(EventDelegator, [{
    key: 'bubble',
    value: function bubble(rawEvent) {
      // eslint-disable-line complexity
      if (!document.body.contains(rawEvent.currentTarget)) {
        return;
      }
      var ev = patchEvent(rawEvent);

      for (var el = ev.target; el && el !== this.roof; el = el.parentElement) {
        if (ev.propagationHasBeenStopped) {
          return;
        }
        this.matchEventAgainstDestinations(el, ev);
      }
    }
  }, {
    key: 'matchEventAgainstDestinations',
    value: function matchEventAgainstDestinations(el, ev) {
      // eslint-disable-line complexity
      for (var i = 0, n = this.destinations.length; i < n; ++i) {
        var dest = this.destinations[i];
        if (!dest.scopeChecker.isStrictlyInRootScope(el)) {
          continue;
        }
        if ((0, _util.matchesSelector)(el, dest.selector)) {
          mutateEventCurrentTarget(ev, el);
          dest.subject.next(ev);
        }
      }
    }
  }, {
    key: 'capture',
    value: function capture(ev) {
      for (var i = 0, n = this.destinations.length; i < n; i++) {
        var dest = this.destinations[i];
        if ((0, _util.matchesSelector)(ev.target, dest.selector)) {
          dest.subject.next(ev);
        }
      }
    }
  }, {
    key: 'addDestination',
    value: function addDestination(subject, namespace) {
      var scope = (0, _util.getScope)(namespace);
      var selector = (0, _util.getSelectors)(namespace);
      var scopeChecker = new _ScopeChecker.ScopeChecker(scope, this.isolateModule);
      this.destinations.push({ subject: subject, scopeChecker: scopeChecker, selector: selector });
    }
  }, {
    key: 'updateTopElement',
    value: function updateTopElement(newTopElement) {
      var eventType = this.eventType;
      var domListener = this.domListener;
      var useCapture = this.useCapture;
      this.topElement.removeEventListener(eventType, domListener, useCapture);
      newTopElement.addEventListener(eventType, domListener, useCapture);
      this.topElement = newTopElement;
    }
  }]);

  return EventDelegator;
}();


/** WEBPACK FOOTER **
 ** ./~/@motorcycle/dom/lib/EventDelegator.js
 **/